/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {$RubyUIText} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/RubyUIText';

export type PanelDisplayProps = ExtendContainerProps<{
    label: string;
    value: string;
    maxWidth: number;
}>;

export const $PanelDisplay: FC<PanelDisplayProps> = (props) => {
    return <$Container name='bottomPanel_display' {...props}>
        {props.children}
        <$RubyUIText
            text={props.value}
            maxWidth={props.maxWidth}
            stylePreset='PANEL_VAL'
            name='value'
            responsive={{box: {y: '-16px'}}}
        />
        <$RubyUIText
            localeID={props.label}
            stylePreset='PANEL_VAL_NAME'
            name={props.label}
            responsive={{box: {y: '32px'}}}
        />
    </$Container>;
};